import { InlineButton } from '#components/atoms/buttons/inline-button/InlineButton.tsx';
import { AuthLayout } from '#components/patterns/layouts/auth/AuthLayout.tsx';

type Props = {
  email?: string;
  onTryAgain: () => void;
};

export function MagicLinkSent({ email, onTryAgain }: Props) {
  return (
    <AuthLayout headerText={<span className="truncate">{email}</span>}>
      <div className="simple-page-content">
        <h1 className="eyebrow color-accent mb-16">Unrecognized device</h1>
        <h2 className="h2 mb-8">Verify your email address</h2>
        <p className="p-bold mb-32">
          If the email entered matches what we have on file, you should see an email in your inbox any moment.
        </p>
        <p className="p-bold">
          Didn’t get it?{' '}
          <InlineButton onClick={onTryAgain} className="a">
            Try again
          </InlineButton>{' '}
          or check your junk mail.
        </p>
      </div>
    </AuthLayout>
  );
}
